import { FC, useEffect } from 'react';
import { Switch } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { uiModel } from 'entities/ui';

import { useLazyGetEmployeeBlockingsQuery } from 'app/services/edpApiV1/employees';
import { useAppDispatch, useAppSelector } from 'app/store';

import style from '../index.module.scss';

type BlockInfoProps = {
  userId: number;
  onChangeBlocking: (id: number, blockingId: number) => void;
};

const BlockInfo: FC<BlockInfoProps> = ({ userId, onChangeBlocking }) => {
  const dispatch = useAppDispatch();
  const [getEmployeeBlockingsTrigger, resultEmployeeBlockings] = useLazyGetEmployeeBlockingsQuery();
  const { isSuccess, data } = resultEmployeeBlockings;
  const blockedInfo = useAppSelector(uiModel.BlockedEmployees.selectors.getBlockInfo);
  const currentBlockInfo = blockedInfo[userId];

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(uiModel.BlockedEmployees.actions.setBlockInfo({ userId, blockInfo: { ...data[0] } }));
    }
  }, [isSuccess]);

  useEffect(() => {
    getEmployeeBlockingsTrigger(userId);
  }, [userId]);

  return currentBlockInfo ? (
    <div className={style.guidEmployeeWrap} key={userId}>
      <span>Причина блокировки: {currentBlockInfo.name}</span>
      <div className={style.employeeBlocked}>
        <Switch
          defaultChecked={true}
          onChange={() => onChangeBlocking(userId, currentBlockInfo.id)}
          disabled={!(currentBlockInfo.id === 3 || currentBlockInfo.id === 4 || currentBlockInfo.id === 2)}
        />
        <span>Снять блокировку</span>
      </div>
    </div>
  ) : (
    <LoadingOutlined />
  );
};

export default BlockInfo;
